(function ($) {
    
    function initAwardsSlider() {
        $( '.awards-slider' ).each( function() {
            $( this ).slick( {
                infinite: true,
                slidesToShow: 5,
                arrows: true,
//                fade: true,
                slidesToScroll: 1,
//                prevArrow: $(this).parents('.product-slider').find('.product-arrows-prev'),
//                nextArrow: $(this).parents('.product-slider').find('.product-arrows-next'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }
    /* Document Ready */
	$(document).ready(function() {
        initAwardsSlider();
	});

})(jQuery);